import { HTTP } from "./http";
// const API_URL = process.env.VUE_APP_API_URL
export async function replacePic(url) {
    if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1) {
        return url;
    } else {
        return process.env.VUE_APP_API_URL + url;
    }
}

//登录
export async function apiLogin(data) {
    let res = await HTTP(`/review_api/login`, "post", data);
    return res;
}
//登出
export async function apiLogout(data) {
    let res = await HTTP(`/review_api/logout`, "post",data);
    return res;
}
// 用户信息
export  async function getUserInfo(){
    let res = await HTTP(`/review_api/authUser`,"get")
    return res
}
 
// 所有轮次
export  async function apiAllRound(){
    let res = await HTTP(`/review_api/round`,"get")
    return res
}
// 当前轮次
export  async function apiCurrentRound(){
    let res = await HTTP(`/review_api/round/current`,"get")
    return res
}
// 评审组
export  async function apiReviewGroup(){
    let res = await HTTP(`/review_api/group`,"get")
    return res
}
// 评审组详情
export  async function apiReviewGroupDetail(id){
    let res = await HTTP(`/review_api/group/${id}`,"get")
    return res
}
// 作品
export  async function apiWork(data){
    let res = await HTTP(`/review_api/work`,"get",data)
    return res
}
// 评分
export  async function apiGrade(data){
    let res = await HTTP(`/review_api/grade`,"post",data)
    return res
}
// 评分暂存
export  async function apiGradeStaging(data){
    let res = await HTTP(`/review_api/staging`,"post",data)
    return res
}
// 初审评级选项列表
export  async function apiGetLevel(data){
    let res = await HTTP(`/review_api/review_first_level`,"get",data)
    return res
}

//去登录
export async function toLogin() {
    let _url = window.location.pathname; 
    window.localStorage.removeItem('app_review_token');
    if(!_url.includes('/login')){
        window.location.href = "/review/login";
    }
    
}


